import { startOfDay } from 'date-fns';

const quarterStartMonth = (quarter: 1 | 2 | 3 | 4): number =>
  (quarter - 1) * 3 + 1;

export const isDateBeforeMinAvailable = (date: Date, minDate: Date): boolean =>
  startOfDay(date) < startOfDay(minDate);

export const isMonthDisabled = (
  year: number,
  month: number,
  minDate: Date
): boolean => {
  const minYear = minDate.getFullYear();
  const minMonth = minDate.getMonth() + 1;

  if (year < minYear) {
    return true;
  }

  if (year > minYear) {
    return false;
  }

  return month < minMonth;
};

export const isQuarterDisabled = (
  year: number,
  quarter: 1 | 2 | 3 | 4,
  minDate: Date
): boolean => isMonthDisabled(year, quarterStartMonth(quarter), minDate);
